import { Button } from '@medly-components/core';
import styled, { css } from 'styled-components';

const nonEditableStyles = css`
    .editor-input {
        padding: 0;
        min-height: max-content;
    }
`;
const editableStyles = css`
    border-radius: 0.8rem;
    border: ${({ theme }) => `0.1rem solid ${theme.colors.grey[500]}}`};
`;

export const EditorWrapper = styled('div')<{ isEditable: boolean }>`
    width: 100%;
    position: relative;
    ${({ isEditable }) => (isEditable ? editableStyles : nonEditableStyles)}
`;

export const InnerEditor = styled('div')`
    position: relative;
    border-radius: 0 0 0.8rem 0.8rem;
`;

export const EditorButton = styled(Button)`
    margin-top: 24px;

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        align-self: flex-end;
    }
`;
